import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var t = /*#__PURE__*/function () {
  function t(_t) {
    _classCallCheck(this, t);

    this.callbacks = _t, this.currentCount = 0, this.callbacks.condition || (this.callbacks.condition = function () {
      return !0;
    });
  }

  _createClass(t, [{
    key: "handle",
    value: function handle(_t2) {
      var s = _t2.data,
          i = s.pointers.size;

      switch (s.action) {
        case "start":
          this.currentCount = i, this.emitStart(_t2);
          break;

        case "added":
          this.emitEnd(this.previousEvent), this.currentCount = i, this.emitStart(_t2);
          break;

        case "update":
          this.emitUpdate(_t2);
          break;

        case "removed":
          this.startEvent && this.emitEnd(this.previousEvent), this.currentCount = i, this.emitStart(_t2);
          break;

        case "end":
          this.emitEnd(_t2), this.currentCount = 0;
      }

      this.previousEvent = _t2;
    }
  }, {
    key: "emitStart",
    value: function emitStart(_t3) {
      this.startEvent = _t3, this.callbacks.condition(this.currentCount, _t3) && this.callbacks.start(this.currentCount, _t3, this.startEvent);
    }
  }, {
    key: "emitUpdate",
    value: function emitUpdate(_t4) {
      this.callbacks.condition(this.currentCount, _t4) && this.callbacks.update(this.currentCount, _t4, this.startEvent);
    }
  }, {
    key: "emitEnd",
    value: function emitEnd(_t5) {
      this.callbacks.condition(this.currentCount, _t5) && this.callbacks.end(this.currentCount, _t5, this.startEvent), this.startEvent = null;
    }
  }]);

  return t;
}();

export { t as DragEventSeparator };